import React from 'react';

import { IconButton, AddIcon } from '@gogame/components';
import Permissions from '@gogame/permissions';

import { customMetricGroupName } from '../ColumnsPicker';

const ADD_SYSTEM_METRIC_PERMISSION = 28;

const GroupAction = ({ name, id, onAddMetric }) => {
  return name === customMetricGroupName ? (
    <IconButton
      tooltip={'Add Custom Metric'}
      icon={<AddIcon />}
      onClick={() => onAddMetric({ groupName: name, groupId: id })}
    />
  ) : (
    <Permissions>
      {({ isActionAllowed }) =>
        isActionAllowed(ADD_SYSTEM_METRIC_PERMISSION) ? (
          <IconButton
            tooltip={`Add ${name} Metric`}
            icon={<AddIcon />}
            onClick={() => onAddMetric({ groupName: name, groupId: id })}
          />
        ) : null
      }
    </Permissions>
  );
};

export default GroupAction;
